import { render } from "./ImportDatabase.vue?vue&type=template&id=79536fce"
import script from "./ImportDatabase.vue?vue&type=script&lang=js"
export * from "./ImportDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__